/* eslint-disable no-console */
/* eslint-disable no-unused-vars */
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import axios from "axios";
import storage from "../firebaseConfig";
import { apiUrl } from "../constants";
import { getEventId } from "../utils";
import { getToken } from "./httpClient";

export default async (data, type) => {
  const obj = data;
  if (obj.image instanceof Object) {
    obj.image = await uploadMedia(obj.image, type);
  }
  return obj;
};

export const uploadToFirebase = async (file, setProgress) => {
  const promise = new Promise((resolve, reject) => {
    const storageRef = ref(storage, `/files/${file.title}`);
    const uploadTask = uploadBytesResumable(storageRef, file.rawFile);
    uploadTask.on(
      "state_changed",
      (snapshot) => {
        const percent = Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
        setProgress({ name: file.title, value: percent });
      },
      (err) => reject(err),
      async () => {
        const url = await getDownloadURL(uploadTask.snapshot.ref).then((link) => link);
        resolve(url);
      }
    );
  });

  return promise;
};

export const uploadBase64Media = async (file) => {
  if (file.startsWith("data:image/png;base64")) {
    const spl = file.split(",").pop();
    const token = await getToken();
    return axios({
      method: "post",
      url: `${apiUrl}/media/upload`,
      data: {
        type: "image/png",
        base64Image: spl,
      },
      headers: {
        "Content-Type": "application/json",
        authorization: token,
        eventid: getEventId(),
      },
    }).then((response) => response.data.image);
  }
  return file;
};

export const uploadMedia = async (file, type) => {
  const img = await convertFileToBase64(file);
  const token = await getToken();
  return axios({
    method: "post",
    url: `${apiUrl}/media/upload`,
    data: {
      type,
      base64Image: img,
    },
    headers: {
      "Content-Type": "application/json",
      authorization: token,
      eventid: getEventId(),
    },
  }).then((response) => response.data.image);
};

export const uploadMediaMultipart = async (file, type) => {
  const formData = new FormData();
  formData.append("type", type);
  formData.append("file", file.rawFile);
  const token = await getToken();
  return axios({
    method: "post",
    url: `${apiUrl}/media/upload`,
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
      enctype: "multipart/form-data",
      authorization: token,
      eventid: getEventId(),
    },
  }).then((response) => response.data.image);
};

const convertFileToBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file.rawFile);
    reader.onload = () => resolve(reader.result.split(",").pop());
    reader.onerror = reject;
  });
